import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import useMulticotizadorSelector from "./useMulticotizadorSelector";
import { postPedidoCotizacion } from "../actions";
import LoadingViewGears from "~styled/loadingView/LoadingViewGears";
import { useHistory } from "react-router-dom";

const useReduxSelector = () =>
  useMulticotizadorSelector((state) => ({
    currentState: state,
  }));

export const SendPostCotizacionesStep = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { currentState } = useReduxSelector();
  const { currentPoliza, cotizacionId } = currentState;

  useEffect(() => {
    if (!currentPoliza.open && !cotizacionId)
      dispatch(postPedidoCotizacion(currentState));
    else history.goBack();

    //eslint-disable-next-line
  }, [dispatch]);

  return <LoadingViewGears />;
};
